export enum DashboardAppNav {
  /**
   * Go to team members settings page.
   */
  TEAM_MEMBERS = "settings:members",
}
